export const columns = [
  {
    field: 'transactionId',
    headerName: 'Transaction Id',
    flex: 1,
    sortable: true,
  },
  {
    field: 'token',
    headerName: 'Token',
    flex: 1,
    sortable: true,
  },
  {
    field: 'last4',
    headerName: 'Credit Card',
    flex: 1,
    sortable: true,
  },
  {
    field: 'contactBuyerName',
    headerName: 'Contact Buyer',
    flex: 1,
    sortable: true,
  },
  {
    field: 'sourceBuyerName',
    headerName: 'Source Request Buyer',
    flex: 1,
    sortable: true,
  },
  {
    field: 'status',
    headerName: 'Status',
    flex: 1,
    sortable: true,
    cellClassName: 'bold-text',
  },
  {
    field: 'processor',
    headerName: 'Gateway',
    flex: 1,
    sortable: true,
  },
  {
    field: 'createdOn',
    headerName: 'Vaulted On',
    flex: 1,
    sortable: true,
    type: 'dateTime',
  },
  {
    field: 'createdBy',
    headerName: 'Vaulted By',
    flex: 1,
    sortable: true,
  },
  {
    field: 'description',
    headerName: 'Details',
    flex: 1,
    sortable: true,
  },
];

export const vaultActStatuses = [
  {
    filterValue: 'Success',
    value: 'SUCCESS',
  },
  {
    filterValue: 'Failed',
    value: 'FAILURE',
  },
  {
    filterValue: 'Unknown',
    value: 'UNKNOWN',
  },
];

export const pageSize = 20;
